import { decimalRound } from "utils/helpers"
import { Analytics } from "utils/analytics"
import { createdBookingLoader } from "modules/BookingCommon/common/queries"
import { useSearchParams } from "utils/customHooks"
import { UserAccount } from "utils/UserAccount"
import { reportInvoice, waitAdmitad } from "utils/ThirdParty/admitad"
import { pushAdvCakeEvent } from "utils/ThirdParty/adv.cake"
import { APP_STATUSES } from "utils/AppStatusContext"

type useOnSuccessFullPaymentProps = (string?: boolean) => void

export function useOnSuccessFullPayment(callback?: useOnSuccessFullPaymentProps) {
    const bookingHash = createdBookingLoader.getHash()
    const { data: bookingDetails } = createdBookingLoader.useGet(bookingHash)
    const searchParams = useSearchParams()
    return function onSuccessfulPayment() {
        callback?.()
        if (bookingDetails) {
            const { is_initial, client_email } = bookingDetails
            if (is_initial) {
                const {
                    booking_hash,
                    psy: { hash_id },
                    price,
                    service_type_id,
                    booking_id,
                } = bookingDetails

                waitAdmitad(() => {
                    reportInvoice(booking_hash, hash_id, service_type_id, price)
                })()

                pushAdvCakeEvent(
                    booking_id,
                    client_email || UserAccount.email || "",
                    decimalRound(price, 2)
                )

                Analytics.gadv_after_first_payment()
            } else {
                if (searchParams.get("from") === APP_STATUSES.client_account) {
                    Analytics.lk_pay_success()
                }
            }
        }
    }
}
